/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { findById2 } from '../fn/organization-unit/find-by-id-2';
import { FindById2$Params } from '../fn/organization-unit/find-by-id-2';
import { findOrgUnits } from '../fn/organization-unit/find-org-units';
import { FindOrgUnits$Params } from '../fn/organization-unit/find-org-units';
import { inactivateOrgUnit } from '../fn/organization-unit/inactivate-org-unit';
import { InactivateOrgUnit$Params } from '../fn/organization-unit/inactivate-org-unit';
import { OrgUnit } from '../models/org-unit';
import { PaginatedDataOrganizationalUnitDto } from '../models/paginated-data-organizational-unit-dto';
import { reactivateOrgUnit } from '../fn/organization-unit/reactivate-org-unit';
import { ReactivateOrgUnit$Params } from '../fn/organization-unit/reactivate-org-unit';
import { updateOrgUnit } from '../fn/organization-unit/update-org-unit';
import { UpdateOrgUnit$Params } from '../fn/organization-unit/update-org-unit';
import { ValidationError } from '../models/validation-error';

@Injectable({ providedIn: 'root' })
export class OrganizationUnitService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findById2()` */
  static readonly FindById2Path = '/api/org-units/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById2()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById2$Response(params: FindById2$Params, context?: HttpContext): Observable<StrictHttpResponse<OrgUnit>> {
    return findById2(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findById2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById2(params: FindById2$Params, context?: HttpContext): Observable<OrgUnit> {
    return this.findById2$Response(params, context).pipe(
      map((r: StrictHttpResponse<OrgUnit>): OrgUnit => r.body)
    );
  }

  /** Path part for operation `updateOrgUnit()` */
  static readonly UpdateOrgUnitPath = '/api/org-units/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOrgUnit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOrgUnit$Response(params: UpdateOrgUnit$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
    return updateOrgUnit(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOrgUnit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOrgUnit(params: UpdateOrgUnit$Params, context?: HttpContext): Observable<Array<ValidationError>> {
    return this.updateOrgUnit$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ValidationError>>): Array<ValidationError> => r.body)
    );
  }

  /** Path part for operation `reactivateOrgUnit()` */
  static readonly ReactivateOrgUnitPath = '/api/org-units/{id}/reactivate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reactivateOrgUnit()` instead.
   *
   * This method doesn't expect any request body.
   */
  reactivateOrgUnit$Response(params: ReactivateOrgUnit$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return reactivateOrgUnit(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reactivateOrgUnit$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reactivateOrgUnit(params: ReactivateOrgUnit$Params, context?: HttpContext): Observable<void> {
    return this.reactivateOrgUnit$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `inactivateOrgUnit()` */
  static readonly InactivateOrgUnitPath = '/api/org-units/{id}/inactivate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inactivateOrgUnit()` instead.
   *
   * This method doesn't expect any request body.
   */
  inactivateOrgUnit$Response(params: InactivateOrgUnit$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return inactivateOrgUnit(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inactivateOrgUnit$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inactivateOrgUnit(params: InactivateOrgUnit$Params, context?: HttpContext): Observable<void> {
    return this.inactivateOrgUnit$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `findOrgUnits()` */
  static readonly FindOrgUnitsPath = '/api/org-units';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findOrgUnits()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOrgUnits$Response(params?: FindOrgUnits$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDataOrganizationalUnitDto>> {
    return findOrgUnits(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findOrgUnits$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOrgUnits(params?: FindOrgUnits$Params, context?: HttpContext): Observable<PaginatedDataOrganizationalUnitDto> {
    return this.findOrgUnits$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedDataOrganizationalUnitDto>): PaginatedDataOrganizationalUnitDto => r.body)
    );
  }

}
